import http from "./http";
function formatDateParams(data) {
  if (!data) return data;

  const newData = { ...data };
  ["startTime", "endTime"].forEach((key) => {
    if (newData[key]) {
      newData[key] = newData[key].replace(/\//g, "-"); // 把斜杠改成横杠
    }
  });

  return newData;
}

export const getPlatformTotalData = (data) => {
  const url = `/api/overview/platformTotalData`;
  return http.post(url, formatDateParams(data));
};
export const platformTotalDataSummary = (data) => {
  const url = `/api/overview/platformTotalDataSummary`;
  return http.post(url, formatDateParams(data));
};
